import { render } from "./DictionaryList.vue?vue&type=template&id=ca1b08a0"
import script from "./DictionaryList.vue?vue&type=script&lang=js"
export * from "./DictionaryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__